// Mock data for CT3 Performance Coaching

export const clientTestimonials = [
  {
    name: 'David Paik',
    title: 'Owner, Bobbie\'s Dairy Dip',
    result: '−22 lbs in 10 weeks',
    quote: 'Didn\'t think I\'d stick with it past week 3. The weekly check-ins made it hard to fall off. Lost 22 lbs and my schedule barely changed.'
  },
  {
    name: 'Cannon Little',
    title: 'Founder, Emory Development & Holdings',
    result: 'First time seeing abs',
    quote: 'Was eating \'healthy\' for years with nothing to show for it. Clifton dialed in my nutrition week one. First time I\'ve ever actually seen my abs.'
  },
  {
    name: 'Magnus Koeninger',
    title: 'Renewal Sales Executive, Mutual of Omaha',
    result: '−18 lbs in 12 weeks',
    quote: 'Work was always my excuse — 60-hour weeks, constant travel. The program fit around my life without asking me to flip everything upside down. Down 18 lbs.'
  },
  {
    name: 'Maya Sagen',
    title: 'Founder, Wellness Society',
    result: '148 → 118 lbs',
    quote: 'I travel constantly and run my own business — I could never stay consistent before CT3. Clifton built a system that held up no matter my schedule. Down 30 pounds and the leanest I\'ve been.'
  },
  {
    name: 'Jake Ault',
    title: 'Property Manager, Emory Development & Holdings',
    result: 'Ready for summer',
    quote: 'The program fit into my day without disrupting it. Everything was laid out clearly — I knew exactly what to do and when. Feeling ready heading into summer.'
  },
  {
    name: 'Tracey Robinson',
    title: 'CNP, Certified Nurse Practitioner',
    result: 'Built-in structure',
    quote: 'Everything is laid out clearly in the app — no confusion, no guesswork. It\'s the kind of structure I needed but couldn\'t build on my own.'
  }
];

export const beforeAfterResults = [
  {
    name: 'Clifton Tant',
    title: 'Head Coach · CT3',
    result: '185 → 205 lbs lean',
    before: 'https://ct3performance.carrd.co/assets/images/image02.jpg?v=09a0b567',
    after: 'https://ct3performance.carrd.co/assets/images/image01.jpg?v=09a0b567',
    singleImage: false
  },
  {
    name: 'Mark Koeninger',
    title: 'IT and Operations',
    result: '238 → 195 lbs',
    before: 'https://assets.macaly-user-data.dev/cdn-cgi/image/format=webp,width=2000,height=2000,fit=scale-down,quality=85,anim=false/a0etk8bhaub9ukay39ocztzm/wpzxay6z8sd1mdhsoy14q4nq/8poPV3AM1Do-8fDK2pEb_.PNG',
    after: null,
    singleImage: true
  },
  {
    name: 'Magnus Koeninger',
    title: 'Renewal Sales Executive',
    result: '+8 lbs muscle · dropped body fat',
    before: 'https://assets.macaly-user-data.dev/cdn-cgi/image/format=webp,width=2000,height=2000,fit=scale-down,quality=85,anim=false/a0etk8bhaub9ukay39ocztzm/wpzxay6z8sd1mdhsoy14q4nq/-oCCeJ4sKII38pnXHjqdW.PNG',
    after: 'https://assets.macaly-user-data.dev/cdn-cgi/image/format=webp,width=2000,height=2000,fit=scale-down,quality=85,anim=false/a0etk8bhaub9ukay39ocztzm/wpzxay6z8sd1mdhsoy14q4nq/r4IXcR9n3G8Yjf-D6_KnW.PNG',
    singleImage: false
  },
  {
    name: 'Cannon Little',
    title: 'Founder, Emory Development & Holdings',
    result: '150 → 163 lbs lean',
    before: 'https://ct3performance.carrd.co/assets/images/image05.jpg?v=09a0b567',
    after: 'https://ct3performance.carrd.co/assets/images/image06.jpg?v=09a0b567',
    singleImage: false
  },
  {
    name: 'Maya Sagen',
    title: 'Founder, Wellness Society',
    result: '148 → 118 lbs',
    before: 'https://assets.macaly-user-data.dev/cdn-cgi/image/format=webp,width=2000,height=2000,fit=scale-down,quality=85,anim=false/a0etk8bhaub9ukay39ocztzm/wpzxay6z8sd1mdhsoy14q4nq/xCufcwSEqB1-VH8NUvfq1.jpeg',
    after: 'https://assets.macaly-user-data.dev/cdn-cgi/image/format=webp,width=2000,height=2000,fit=scale-down,quality=85,anim=false/a0etk8bhaub9ukay39ocztzm/wpzxay6z8sd1mdhsoy14q4nq/tON0XUBxiTg9XhDhxS1Kt.jpeg',
    singleImage: false
  },
  {
    name: 'Matthew Norman',
    title: 'College Student',
    result: '−40+ lbs in 6 months',
    before: 'https://ct3performance.carrd.co/assets/images/image03.jpg?v=09a0b567',
    after: 'https://ct3performance.carrd.co/assets/images/image04.jpg?v=09a0b567',
    singleImage: false
  }
];

export const APPLY_URL = 'https://tally.so/r/LZYBGy';

export const heroImage = 'https://customer-assets.emergentagent.com/job_driven-12week/artifacts/8izh3745_IMG_6842.jpeg';
export const coachImage = 'https://customer-assets.emergentagent.com/job_driven-12week/artifacts/qoggg5dq_B25544AF-B9CD-4614-9A0B-DDAD38ACC571.png';

export const frameworkSteps = [
  {
    number: '01',
    title: 'Structured Training',
    description: 'Progressive strength and hypertrophy programming built around your schedule, recovery, and experience level. No more guessing what to do at the gym.'
  },
  {
    number: '02',
    title: 'Precision Nutrition',
    description: 'Calories, protein, carbs, and fats set for your specific body and goal — then adjusted weekly based on real progress data. Not a generic diet.'
  },
  {
    number: '03',
    title: 'Weekly Adjustments',
    description: 'Your training, cardio, and nutrition are reviewed and optimized every single week based on actual results. The program evolves with you.'
  },
  {
    number: '04',
    title: 'Habit Systems',
    description: 'Daily structure around steps, sleep, hydration, and recovery that ensures consistent progress — even when life gets busy and unpredictable.'
  }
];

export const programIncludes = [
  {
    title: 'Custom Training Program',
    description: 'Structured workouts built around your schedule, recovery, and experience level.'
  },
  {
    title: 'Precision Nutrition Targets',
    description: 'Macros tailored to your body and adjusted weekly based on real progress data.'
  },
  {
    title: 'Weekly Coaching Check-Ins',
    description: 'Training, cardio, and nutrition reviewed and optimized every single week.'
  },
  {
    title: 'Habit & Lifestyle Systems',
    description: 'Daily structure around steps, sleep, hydration, and recovery.'
  },
  {
    title: 'Progress Tracking',
    description: 'Clear metrics to keep you consistent and on track throughout your 12, 24, or 52-week program.'
  },
  {
    title: 'Direct Coaching Access',
    description: 'Real coaching throughout. Not a course. Not a template. Direct access.'
  }
];
